import reducer from './reducers';
import * as fifthFlowsActions from './actions';
import * as fifthFlowsSelectors from './selectors';

export { fifthFlowsActions, fifthFlowsSelectors };
export default reducer;
